export const freeCredits = 3;
export const plusCredits = 6;
export const creditCost = '$2.99 USD';
export const plusCost = '$9.99 USD';
